export const company = {
  name: 'AGNISAFE ENGINEERING LLP',
  shortName: 'AGNISAFE',
  tagline: 'Pure Water. Sustainable Tomorrow.',
  website: 'www.agnisafeengineering.com',
  email: 'info@agnisafeengineering.com',
  phone: '+91 94274 72529',
  phoneRaw: '+919427472529',
  address: 'D/2- 326, SP Ring Rd, Sanathal, Ahmedabad, Gujarat 382210',
};

export const navLinks = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'products', label: 'Our Products' },
  { id: 'features', label: 'Features' },
  { id: 'contact', label: 'Contact Us' },
];

export const about = {
  paragraphs: [
    'AGNISAFE ENGINEERING LLP is one of the leading companies for the design, construction and operational management of drinking water, wastewater treatment and water reuse plants for both the municipal and industrial sectors.',
    'AGNISAFE ENGINEERING LLP plants are designed and built within the framework of a holistic approach, which accounts for both ecological and economic factors. Long-term experience and comprehensive process technology competencies facilitate the creation of individually planned plants, which match respective special requirements.',
    'The services offered by the AGNISAFE ENGINEERING LLP team include design and engineering, the supply of equipment and retrofitting, installation and supervision, start-up and commissioning, after-sales service and plant operation, and cover diverse schemes such as Design-Build-Operate (DBO), Engineering-Procurement-Construction (EPC), turnkey order realization, the supply of system components, and the upgrading and enlargement of existing plants.',
  ],
  schemes: [
    'Design-Build-Operate (DBO)',
    'Engineering-Procurement-Construction (EPC)',
    'Turnkey Order Realization',
    'Supply of System Components',
    'Upgrading & Enlargement of Plants',
  ],
  vision:
    'To exceed our customers’ expectations through innovation, precision, and reliable engineering solutions. We are committed to adopting advanced technologies and modern practices to deliver superior quality, performance, and durability across every project. Our vision is to create sustainable and efficient solutions while building a platform that encourages skilled professionals, continuous improvement, and long-term growth.',
  mission: [
    'To become a trusted and responsible organization committed to protecting water, preserving natural resources, and creating a sustainable future. Along with delivering excellence in our business, we are dedicated to reducing pollution, promoting environmental awareness, and encouraging responsible practices.',
    'We strive to contribute to society through initiatives such as water conservation, tree plantation, plastic pollution reduction, and other environmental activities. Our mission is to combine business growth with social responsibility and create a cleaner, healthier, and greener world.',
  ],
  missionQuote: 'Together, let us take responsibility today to build a better tomorrow.',
};

// `image` is a photo in public/images/. Products with `image: null` show a
// blueprint-style schematic instead until a real photo is added.
export const products = [
  {
    id: 'wtp',
    code: 'WTP',
    name: 'Water Treatment Plant',
    subtitle: 'Design & Engineering',
    image: '/images/wtp.jpg',
    summary: 'Centralized treatment for large volumes of clean, usable water.',
    points: [
      'Centralized water treatment plants utilize processes such as coagulation, flocculation, and disinfection to provide an efficient and cost-effective solution for treating large quantities of water.',
      'Water treatment is a comprehensive process designed to improve water quality and make it suitable for specific end uses.',
      'Treated water can be used for drinking, industrial applications, water supply, irrigation, river flow maintenance, recreational purposes, and other applications.',
      'Meanwhile also ensuring that water can be safely returned to the environment.',
    ],
  },
  {
    id: 'stp',
    code: 'STP',
    name: 'Sewage Treatment Plant',
    subtitle: 'Design, Installation & Commissioning',
    image: '/images/stp.jpg',
    summary: 'Physical, chemical & biological treatment of domestic sewage.',
    points: [
      'Sewage treatment is the process of removing contaminants from wastewater, primarily from domestic sewage.',
      'It involves physical, chemical, and biological treatment processes to eliminate pollutants and produce environmentally safe treated wastewater.',
      'A by-product of sewage treatment is generally a semi-solid waste or sludge, known as sewage sludge, which undergoes further treatment before being suitable for safe disposal or beneficial applications.',
      'At AGNISAFE ENGINEERING LLP, we provide customized sewage treatment solutions using advanced technologies based on project requirements.',
    ],
    tags: ['MBBR', 'MBR', 'ASP', 'UASB', 'SBR', 'CSTP'],
    tagsLabel: 'Technologies',
  },
  {
    id: 'etp',
    code: 'ETP',
    name: 'Effluent Treatment Plant',
    subtitle: 'Industrial Wastewater Solutions',
    image: '/images/etp.jpg',
    summary: 'Treating industrial effluent for safe reuse or discharge.',
    points: [
      'An Effluent Treatment Plant (ETP) is designed to treat industrial wastewater generated from factories and manufacturing processes, enabling the treated water to be safely reused for secondary applications or discharged into the environment.',
      'Industrial effluents may contain various contaminants such as by-products, washing and cleaning agents, solvents, chemicals, oils, and other pollutants.',
      'The ETP is designed to effectively remove these contaminants and ensure that the treated water meets the required environmental standards.',
    ],
    tags: [
      'Effluent Gravity Separator / O&G Trap',
      'Primary Sedimentation',
      'Advanced Chemical Treatment',
      'Biological Treatment',
      'Advanced Sludge Separation',
      'Advanced Filtration Systems',
      'Microfiltration (UF + RO)',
    ],
    tagsLabel: 'Treatment stages',
  },
  {
    id: 'gwt',
    code: 'GWT',
    name: 'Grey Water Treatment Plant',
    subtitle: 'Water Recovery & Reuse',
    image: null,
    summary: 'Recycle bathroom & basin water for non-potable reuse.',
    points: [
      'Grey water is domestic wastewater generated from sources such as bathrooms, wash basins, showers, and other household activities, excluding toilet sewage.',
      'Unlike black water, grey water generally contains lower levels of organic contaminants. It can be collected, treated, and safely reused for various non-potable applications such as toilet flushing, car washing, gardening, landscaping, and irrigation.',
      'At AGNISAFE ENGINEERING LLP, customized Grey Water Treatment solutions help reduce freshwater consumption, promote water recycling, and support sustainable water management.',
    ],
    tags: ['Toilet Flushing', 'Car Washing', 'Gardening', 'Landscaping', 'Irrigation'],
    tagsLabel: 'Reuse applications',
  },
  {
    id: 'zld',
    code: 'ZLD',
    name: 'Zero Liquid Discharge Plant',
    subtitle: 'Advanced Water Recovery Solutions',
    image: null,
    summary: 'Maximum water recovery with virtually no liquid discharge.',
    points: [
      'Zero Liquid Discharge (ZLD) is an advanced water treatment approach designed to recover and reuse water while minimizing liquid waste and converting concentrated contaminants into solid waste.',
      'While conventional water treatment processes aim to maximize freshwater recovery and minimize waste, ZLD provides a more comprehensive solution where water recovery is maximized and liquid discharge is virtually eliminated.',
      'As wastewater becomes more concentrated, the levels of salinity, scaling compounds, and organic contaminants increase. ZLD systems address these challenges through advanced processes such as Multi-Effect Evaporators (MEE) and other evaporation and crystallization technologies.',
      'In a typical MEE system, condensate is used to preheat the liquor before evaporation. High-TDS reject water is heated and circulated to further concentrate the dissolved salts, ultimately enabling effective water recovery and solid waste separation.',
      'AGNISAFE ENGINEERING LLP provides customized ZLD solutions based on wastewater characteristics, recovery requirements, and specific industrial applications.',
    ],
    tags: ['Multi-Effect Evaporator (MEE)', 'Evaporation', 'Crystallization'],
    tagsLabel: 'Key processes',
  },
];

export const coreFeatures = [
  'Customized solutions designed to fulfill individual customer requirements.',
  'Minimal visual and aesthetic impact.',
  'Flexible and convenient supply lead times.',
  'Designed to comply with the highest standards as per Pollution Control Board norms.',
  'Efficient flow balancing within the primary tank.',
  'Capable of handling varying flow rates and load conditions.',
  'Reliable operation with provision for standby facilities.',
  'No internal moving components, minimizing the requirement for maintenance access.',
  'Large and easily accessible inspection covers.',
  'Humus and primary sludge are collected and stored at a single location for easy transportation.',
  'Available in both pre-fabricated and civil construction options.',
  'Complete technical, installation, and operational support from a trained and experienced team.',
  'Solutions available from KLD to MLD capacity.',
];

export const services = [
  'Comprehensive engineering design for water and wastewater treatment plants.',
  'Manufacturing, assembly, and installation of water treatment systems.',
  'Wastewater characterization, assessment, and site surveys.',
  'Water and wastewater quality analysis.',
  'Upgradation, refurbishment, and retrofitting of existing and aging treatment plants.',
  'Design, supply, and operation of pilot plants, including data collection, analysis, and interpretation.',
  'Complete turnkey project execution.',
  'Build, Operate & Manage (BOM) schemes.',
  'Plant operation and maintenance contracts.',
  'Procurement and sourcing services.',
  'End-to-end project management.',
];

export const expertise = [
  'Apartments / Bungalows / Houses',
  'Factories / Workshops / Industries',
  'Commercial Complexes',
  'Hotels / Resorts',
  'Hostels / Universities / Schools',
  'Office Buildings / Training Centers',
  'Hospitals',
  'National Parks / Zoos / Temples',
  'Bus Terminals / Railway Stations / Airports / Harbors',
  'Stadiums / Shopping Malls',
];

export const heroImage = '/images/plant-aerial.jpg';
export const qrImage = '/images/qr-website.svg';

// Scrolling ticker under the hero.
export const technologies = [
  'MBBR', 'MBR', 'SBR', 'ASP', 'UASB', 'CSTP', 'UF + RO', 'Multi-Effect Evaporator',
  'Crystallization', 'Coagulation', 'Flocculation', 'Disinfection', 'O&G Trap', 'Sludge Separation',
];

// How a project flows from enquiry to operation.
export const processSteps = [
  { title: 'Survey', text: 'Site survey & wastewater characterization' },
  { title: 'Design', text: 'Process & engineering design' },
  { title: 'Build', text: 'Manufacture, supply & installation' },
  { title: 'Commission', text: 'Start-up & performance testing' },
  { title: 'Operate', text: 'O&M, after-sales & upgrades' },
];
